import Vue from 'vue';
import { sipEndpointAPI } from 'widget/api/sipEndpointAPI';
import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';

const state = {
  paramsSipUser: {
    caller_type: "",
    conversation_id: null,
    inbox_id: null,
  },
  paramsSipAgent: {
    caller_type: "",
    conversation_id: null,
    inbox_id: null,
  },
  userData: {
    balance_positive: false,
    credentials: {
      companyName: "",
      sip_password: "",
      sip_username: "",
    },
  },
  agentData: {
    balance_positive: false,
    credentials: {
      agent_id: null,
      sip_password: "",
      sip_username: "",
    },
  },
  videoData: {
    is_conversation_assigned: false,
    is_video_available: false,
    redirect_keyword: "",
  },
  website_token: "",
  sipFlag: false,
  startFlag: false,
};

export const getters = {
  getUserData: $state => $state.userData,
  getAgentData: $state => $state.agentData,
  getVideoData: $state => $state.videoData,
  getSipFlag: $state => $state.sipFlag,
  getStartFlag: $state => $state.startFlag,
  getRedirectKeyword: $state => $state.videoData.redirect_keyword,
};

export const actions = {
  fetchUserData: async ({ commit, state }) => {
    const { data } = await sipEndpointAPI.getSIPEndpoints({
        sip: {
            ...state.paramsSipUser
        }
    });
    commit('setUserData', data);
  },
  fetchIsVideoAbailable: async ({ commit, state }) => {
    const { data } = await sipEndpointAPI.getIsVideoAvailable(state.paramsSipUser.inbox_id, state.website_token, state.paramsSipUser.conversation_id);
    commit('setVideoData', data);
  },
  fetchAgentData: async ({ commit, state }) => {
    const { data } = await sipEndpointAPI.getSIPEndpoints({
        sip: {
            ...state.paramsSipAgent
        }
    });
    commit('setAgentData', data);
  },
};

export const mutations = {
  setAgentData($state, data) {
    Vue.set($state, 'agentData', data);
  },
  setUserData($state, data) {
    Vue.set($state, 'userData', data);
  },
  setVideoData($state, data) {
    Vue.set($state, 'videoData', data);
  },
  setWebsiteToken($state, data) {
    Vue.set($state, 'website_token', data);
  },
  setParamsSipUser($state, data) {
    Vue.set($state, 'paramsSipUser', data);
  },
  setParamsSipAgent($state, data) {
    Vue.set($state, 'paramsSipAgent', data);
  },
  toogleSipFlag($state) {
    Vue.set($state, 'sipFlag', !$state.sipFlag);
  },
  toogleStartFlag($state) {
    Vue.set($state, 'startFlag', !$state.startFlag);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
